/*
 * @Author: caiqin.xie
 * @since: 2023-07-20 09:44:30
 * @lastTime: 2023-07-28 17:47:59
 * @LastEditors: caiqin.xie
 * @message:
 */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Header/index";
import Footer from "../../../../components/Footer/index";
import GameItem from "../components/GameItem";
// import { Pagination } from 'swiper';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/scss';
// import 'swiper/scss/pagination';
// import '../../../../common/styles/rewriteSwiper.scss'
import styles from "./index.module.scss";
import gameMock from "../components/GameItem/gameMock";

const gameBanner = require('../../../../static/images/game_detail_banner.jpg')
const gameAdBanner = require('../../../../static/images/game_ad_banner.jpg')
const gameSwiper1 = require('../../../../static/images/game_detail_swiper_1.png')
const gameSwiper2 = require('../../../../static/images/game_detail_swiper_2.png')

const swiperList:string[] = [gameSwiper1, gameSwiper2, gameSwiper1, gameSwiper2]

const Game = (props: any) => {
  const {ctry, words} = props.data
  return (
    <div>
      <Helmet>
        {/* <title>{words.support_tilte}</title>
        <meta name="description" content={words.blog_description} />
        <meta name="keywords" content={words.blog_keywods} /> */}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['game-wrap']}>
        {/* banner区 */}
        <div className={styles["banner-wrap"]}>
          <div className={styles['banner-img']} >
            <img src={gameBanner} alt="banner_img"/>
          </div>
          <div className={styles["banner-content-wrap"]}>
            <div className={styles['banner-content']}>
              <h1 className={styles["banner-title"]}>Crash Bandicoot 4: It's About Time</h1>
              <p className={styles['game-label']}>
                Available on <span className={styles['label']}>PICO 4</span><span className={styles['label']}>PICO 4 Pro</span>
              </p>
              <p className={styles['game-price']}>$ 35.75</p>
              <ul className={styles['game-info']}>
                <li>· Required for online play</li>
                <li>· 1 player</li>
                <li>· Supports up to 6 online players with PS Plus</li>
              </ul>
            </div>
          </div>
        </div>
        {/* 轮播 */}
        {/* <div className={styles['swiper']}>
          <Swiper
            className={styles['game-swiper']}
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={24}
            slidesPerView='auto'
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log('slide change')}
          >
            {swiperList.map((item, index) => (
              <SwiperSlide key={index}>
                <img src={item} alt="" className={styles['swiper-img']} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>  */}
        <div className={styles['game-overview']}>
          <div className={styles['overview-content']}>
            <h2 className={styles['title']}>GAME OVERVIEW</h2>
            <h3 className={styles['sub-title']}>Crash forward into a time-shatteredadventure with your favouritemarsupials.</h3>
            <p className={styles['desc']}>The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.</p>
          </div>
        </div>
        {/* 内容区 */}
        <div className={styles["game-content"]}>
          <section className={`${styles['game-section']} ${styles['game-features']}`}>
            <h2 className={styles['section-title']}>Game key features</h2>
            <div className={styles['game-list']}>
              {gameMock.slice(1,5).map(item => (
                <GameItem
                key={item.id}
                gameData={item}
                className={styles['custom-game-item']}
                contentClassName={styles['custom-item-content']}></GameItem>
              ))}
            </div>
          </section>

          <div className={styles['game-banner']}>
            <img className={styles['game-banner-img']} src={gameAdBanner} alt="" />
            <div className={styles['game-banner-content']}>
              <h2 className={styles['game-banner-title']}>Your game guide to Final Fantasy 14</h2>
              <p className={styles['game-banner-desc']}>The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final </p>
              <span className={styles['load-more-purple']}>Read more</span>
            </div>
          </div>
          <div className={styles['game-banner']}>
            <img className={styles['game-banner-img']} src={gameAdBanner} alt="" />
            <div className={styles['game-banner-content']}>
              <h2 className={styles['game-banner-title']}>Not miss out to be a gaming expert</h2>
              <p className={styles['game-banner-desc']}>The 6.0 version of Final Fantasy 14 titled "The End of the Dawn" has been highly praised and launched.The 6.0 version of Final </p>
              <span className={styles['load-more-purple']}>Read more</span>
            </div>
          </div>

          <section className={`${styles['game-section']} ${styles['more-games']}`}>
            <h2 className={styles['section-title']}>More games like Final Fantasy 14</h2>
            <div className={styles['more-game-list']}>
              {gameMock.slice(0,6).map(item => (
                <div className={styles['game-item']} key={item.id}>
                  <img className={styles['game-pic']} src={item.gameImg} alt="" />
                  <p className={styles['game-title']}>{item.title}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};
Game.getInitialProps = () => {
  return new Promise((resolev, reject) => {
    setTimeout(() => {
      resolev({ title: "游戏" });
    }, 200);
  });
};
export default Game;
